import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/router';
import {
  getPromotedBrands,
  getBrandsByCategory,
  getAllBrands,
} from 'aster-foundation/core/epharmacy/Category/redux/action';
import PropTypes from 'prop-types';
import { FLAGSMITH_KEYS, KSA_FLAGSMITH_KEYS, ONE_ASTER_CATEGORY_HOME, ONLINE_PHARMACY_ROUTE } from '@common/Utility/constants';
import {
  BRANDS,
  DEALS_ICON,
  EXPRESS_ICON,
  HOVER_BRAND,
  IC_LEFT_PAGINATION_ARROW,
  IC_RIGHT_ARROW,
  NODEALS,
  PRODUCT_CARD_DEFAULT,
  VIEWALL,
  VIEWALLL_LEFT,
  YESEXPRESS,
} from '../../../Assets/images';
import SubL3Categories from '../SubL3Categories/SubL3Categories';
import { MegaMenuStyled } from './MegaMenuStyled';
import logger from '@common/Utility/logger';
import { useDispatch, useSelector } from 'react-redux';
import ShopByBrands from '../../ShopByBrands/ShopByBrands';
import flagsmith from 'flagsmith/isomorphic';
import { dataLayerMenuClick, dataLayerSendEvent } from '@common/Utility/analytics-utils';
import { errorHandling, errorHandlingEpharmacy, getReferralPageForGA, getImageUrlWithSize, checkIfCurrentRegionIsSaudi } from '@common/Utility/common-utils';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../../i18n';

const MegaMenu = ({ categoryList, screenName, pageType }) => {
  const router = useRouter();
  const referralPageForGa = getReferralPageForGA(router.asPath);
  const t = useTranslation();

  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [subCategoryL2Data, setSubCategoryL2Data] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [subL3Data, setSubL3Data] = useState([]);
  const [subL3Name, setSubL3Name] = useState('');
  const [isDelay, setIsDelay] = useState(false);
  const [shopByBrand, setShopByBrand] = useState([]);
  const [shopBrand, setShopBrand] = React.useState([]);
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const [isDealsHovered, setIsDealsHovered] = useState(false);
  const [isExpressHovered, setIsExpressHovered] = useState(false);
  const [currentLang, setCurrentLanguage] = useState('');
  const [isSaudiRegion, setIsSaudiRegion] = useState(false);

  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const dispatch = useDispatch();
  const aemegamenu = flagsmith.getValue('ae_web_megamenu', { json: true });
  const screenPathName = router?.pathname;
  const generateURL = useNavigationURL();
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});
  const moreMenu = web_feature_flaging?.moreMenu;

  const DEALS_OPTION = {
    name: aemegamenu?.commonmenu?.Deals?.title,
    url: aemegamenu?.commonmenu?.Deals?.url,
    active: moreMenu?.find((item) => item.key === KSA_FLAGSMITH_KEYS?.MORE_MENU?.MEGAMENU_DEALS)?.active,
  };

  const EXPRESS_OPTION = {
    name: aemegamenu?.commonmenu?.Express?.title,
    url: aemegamenu?.commonmenu?.Express?.url,
    active: moreMenu?.find((item) => item.key === KSA_FLAGSMITH_KEYS?.MORE_MENU?.MEGAMENU_EXPRESS)?.active,
  };

  const handleStaticOptionClick = (url, name) => {
    router.push(generateURL(url));

    dataLayerSendEvent('static_option_clicked', {
      button_name: name,
      event: 'homepage_static_menu_link',
      screen_name: referralPageForGa,
    });
  };

  const handleCategoryHover = (categoryId) => {
    setHoveredCategory(categoryId);
  };

  useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
      if(checkIfCurrentRegionIsSaudi()){
        setIsSaudiRegion(true)
      }
    }
  }, []);

  useEffect(() => {
    if (hoveredCategory && (guestLogin || userLogin)) {
      const params = {
        categoryId: hoveredCategory,
      };
      dispatch(
        getBrandsByCategory({
          params,
          onSuccess: (response) => {
            setShopByBrand(response?.data);
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenPathName, referralPageForGa);
            logger.error(err);
          },
        }),
      );
    }
  }, [hoveredCategory, guestLogin, userLogin]);

  useEffect(() => {
    if (userLogin || guestLogin) {
      const params = {
        key: 'promoted',
        value: true,
      };

      dispatch(
        getAllBrands({
          params: params,
          onSuccess: (response) => {
            setShopBrand(response?.data);
          },
          onFailure: (err) => {
            errorHandling(err, true, screenPathName, referralPageForGa);
            // toast.error('Something went wrong');
          },
        }),
      );
    }
  }, [userLogin, userLogin, hoveredCategory]);

  // useEffect(() => {
  //   dispatch(
  //     getPromotedBrands({
  //       onSuccess: (response) => {
  //         setShopByBrand(response?.data?.brandList);
  //       },
  //       onFailure: (err) => {
  //         logger.error(err);
  //       },
  //     }),
  //   );
  // }, [guestLogin, userLogin]);

  const handleCategoryHoverEnd = () => {
    setHoveredCategory(null);
    setSelectedSubcategory(null);
    setSubL3Data([]);
    setFilteredData([]);
    setSubCategoryL2Data([]);
    setIsDelay(false);
  };
  const handleL3CategoryHover = (l3Id, l3Category) => {
    if (l3Category?.subCategories) {
      setSubL3Data(l3Category?.subCategories);
      setSubL3Name(l3Category?.name);
    }
  };

  const delay = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const getCategoriesData = async (list) => {
    await delay(600);
    setIsDelay(true);
    if (list?.subCategories?.length > 0) {
      const value = list?.subCategories?.filter((item) => item?.subCategories);
      const filteredValue = list?.subCategories?.filter((item) => !item?.subCategories);
      if (value?.length > 0) {
        setSubCategoryL2Data(value);
        setSubL3Data(value?.[0]?.subCategories);
        setSubL3Name(value?.[0]?.name);
      } else {
        setSubCategoryL2Data([]);
      }

      if (filteredValue?.length > 0) {
        setFilteredData(filteredValue || []);
      } else {
        setFilteredData([]);
      }
    }
    return [];
  };
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const subCatItem = document.getElementsByClassName('subcategory-item');
      if (subCategoryL2Data?.length !== filteredData?.length) {
        subCatItem?.[0]?.classList?.add('active');
      }
      Array.from(subCatItem).map((item) => {
        item?.addEventListener('mouseenter', () => {
          if (subCatItem?.[0]?.className?.includes('active')) {
            subCatItem?.[0]?.classList?.remove('active');
          }
          item?.classList?.add('active');
        });
        item?.addEventListener('mouseleave', () => {
          item?.classList?.remove('active');
        });
      });
    }
  }, [hoveredCategory, subCategoryL2Data?.length]);

  const getHeight = () => {
    if (subCategoryL2Data?.length) {
      if (filteredData?.length === 0) {
        return subCategoryL2Data?.length > subL3Data?.length ? subCategoryL2Data?.length : subL3Data?.length;
      }
      const addition = Number(subCategoryL2Data?.length) + Number(filteredData?.length);
      return addition > subL3Data?.length ? addition : subL3Data?.length;
    }
    return filteredData?.length;
  };

  const height = getHeight();

  const viewAllLinkClickEvent = () => {
    dataLayerSendEvent('view_all_link_click', {
      screen_name:
        screenName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
          ? 'epharmacy homepage'
          : screenName === ONE_ASTER_CATEGORY_HOME?.CORE
          ? 'asco homepage'
          : screenName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
          ? 'doctor consult homepage'
          : router?.query?.slugname
          ? router?.query?.slugname
          : screenName,
      page_type: pageType,
      page_id: null,
      myaster_category: 'epharmacy',
      section_name: 'brand_static_menu',
      type: 'brand carousel',
    });
    sendEventToSmartLook('view_all_link_click');
  };

  return (
    <MegaMenuStyled
      className={`${currentLang && isRTL(currentLang) ? 'rtl' : ''} ${isSaudiRegion ? 'ksa' : ''}`}
      enlargeHeight={height}
      border={subCategoryL2Data?.length || filteredData?.length}
      showLocation={web_feature_flaging?.isLocationEnable}
      showStaticMegaMenu={DEALS_OPTION?.active || EXPRESS_OPTION?.active}
    >
      <div className="category-wrapper" onMouseLeave={handleCategoryHoverEnd}>
          <div
            className="category-namebrand"
            onMouseLeave={() => setIsLogoHovered(false)}
            onMouseEnter={() => {
              setHoveredCategory('brand');
              setIsLogoHovered(true);
            }}
          >
            <div className="category-wrapper">
              <span
                className={`category-namesbrand   ${'brand' === selectedSubcategory ? 'active' : ''}`}
                onMouseLeave={() => setIsLogoHovered(false)}
              >
                <div className="headLogo">
                  <Image src={isLogoHovered ? HOVER_BRAND.src : BRANDS.src} width={14} height={14} />
                </div>

              <div
                className="Brandshead"
                onMouseEnter={() => {
                  setIsLogoHovered(true);
                }}
                onClick={() => {
                  dataLayerMenuClick(screenName, pageType, 'Brands', 'Mega menu');
                  router.push(generateURL(`${ONLINE_PHARMACY_ROUTE}/brandlisting`));
                }}
              >
                {' '}
                <div className="innerbrand">{t('MegaMenu.txtBrands')}</div>
              </div>
            </span>
          </div>

            {hoveredCategory === 'brand' && (
              <>
                <div className="overlay" onMouseEnter={handleCategoryHoverEnd} />
                <div className="brandList">
                  <div className="brandView" onClick={() => router.push(generateURL(`${ONLINE_PHARMACY_ROUTE}/brandlisting`))}>
                    {' '}
                    <div className="brands">{t('MegaMenu.txtBrandsCaps')}</div>
                    <div className="view">
                      <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/brandlisting`)} passHref>
                        <a onClick={() => viewAllLinkClickEvent()}>{t('MegaMenu.txtViewAll')}</a>
                      </Link>
                    </div>
                    <div className="viewIcon">
                      <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/brandlisting`)} passHref>
                        <a>
                          <Image src={currentLang && isRTL(currentLang) ? VIEWALLL_LEFT.src : VIEWALL.src} width={16} height={16} />
                        </a>
                      </Link>
                    </div>
                  </div>
                  <div className="brand-cards-container">
                    {shopBrand.slice(0, 33)?.map((brand, index) => (
                      <div key={brand.id} className="brand-card">
                        <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/${brand.brandUrl}`)} passHref>
                          <a>
                            <Image
                              src={getImageUrlWithSize(brand?.image, 120, 60) || PRODUCT_CARD_DEFAULT.src}
                              alt={brand?.title}
                              width="120px"
                              height="60px"
                              onClick={(e) => {
                                dataLayerSendEvent('brand_item_clicked', {
                                  brand_name: brand?.title,
                                  brand_id: brand.id,
                                  position: index+1,
                                  section_name: 'brand_static_menu',
                                  myaster_category: 'epharmacy',
                                  page_type: pageType,
                                  screen_name: screenName,
                                });
                              }}
                              unoptimized
                            />
                          </a>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="category-w">
          <div className="category-list">
            {categoryList?.map((category) => (
              <div
                key={category?.id}
                onMouseEnter={() => setSelectedSubcategory(category?.subCategories?.[0]?.parentId)}
              >
                <div
                  className="category-name"
                  onMouseEnter={() => {
                    handleCategoryHover(category?.id);
                    getCategoriesData(category);
                  }}
                >
                  <div
                    className="category-wrapper"
                    onClick={() => {
                      dataLayerMenuClick(screenName, pageType, category?.name, 'Mega menu');
                      router.push({
                        pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${category?.webNavigationURL || category?.categoryUrl}`),
                      });
                    }}
                  >
                    <span className={`category-names  ${category?.id === selectedSubcategory ? 'active' : ''}`}>
                      {category?.name}
                    </span>
                  </div>

                  {category?.id === hoveredCategory && isDelay && (
                    <>
                      <div className="overlay" onMouseEnter={handleCategoryHoverEnd} />
                      <div className="subcategory-list">
                        {subCategoryL2Data?.length !== filteredData?.length &&
                          subCategoryL2Data.slice(0, 12).map(
                            (subCategory) =>
                              subCategory?.subCategories && (
                                <div className="level2Category" key={subCategory?.id}>
                                  <Link
                                    href={generateURL(`${ONLINE_PHARMACY_ROUTE}/c/${subCategory?.name
                                      ?.toLowerCase()
                                      ?.replace(/ /g, '-')
                                      ?.replace(/[^a-zA-Z0-9-]/g, '-')
                                      ?.replace(/-{2,}/g, '-')}/${subCategory?.id}`)}
                                    passHref
                                  >
                                    <a>
                                      <div
                                        key={subCategory?.id}
                                        className="subcategory-item"
                                        onMouseEnter={() => handleL3CategoryHover(subCategory?.id, subCategory)}
                                        onClick={() => {
                                          router.push(
                                            generateURL(`${ONLINE_PHARMACY_ROUTE}/c/${subCategory?.name
                                              ?.toLowerCase()
                                              ?.replace(/ /g, '-')
                                              ?.replace(/[^a-zA-Z0-9-]/g, '-')
                                              ?.replace(/-{2,}/g, '-')}/${subCategory?.id}`),
                                          );
                                        }}
                                      >
                                        <div>{subCategory?.name}</div>
                                        <div className="ic-arrow">
                                          <Image src={currentLang && isRTL(currentLang) ? IC_RIGHT_ARROW.src : IC_LEFT_PAGINATION_ARROW.src} alt="" layout="fill" />
                                        </div>
                                      </div>
                                    </a>
                                  </Link>
                                  {subCategory?.subCategories?.length > 0 && subL3Data?.length > 0 && (
                                    <SubL3Categories
                                      subL3category={subL3Data}
                                      name={subL3Name}
                                      shopByBrand={shopByBrand?.[0]?.featuredBrandList}
                                      showFullWidth={false}
                                      pageType={pageType}
                                      screenName={screenName}
                                    />
                                  )}
                                </div>
                              ),
                          )}
                        <div className="subCategoryLevel2">
                          {subCategoryL2Data?.length !== 0 &&
                            filteredData?.length > 0 &&
                            filteredData.slice(0, 3).map((item) => (
                              <div key={item?.id}>
                                <div className="catImage">
                                  <Link
                                    href={generateURL(`${ONLINE_PHARMACY_ROUTE}/c/${item?.name
                                      ?.toLowerCase()
                                      ?.replace(/ /g, '-')
                                      ?.replace(/[^a-zA-Z0-9-]/g, '-')
                                      ?.replace(/-{2,}/g, '-')}/${item?.id}`)}
                                    passHref
                                  >
                                    <a>
                                      <Image src={getImageUrlWithSize(item?.image, 59, 59) || PRODUCT_CARD_DEFAULT.src} height={59} width={59} unoptimized/>
                                    </a>
                                  </Link>
                                </div>
                                <div className="catTitle"> {item?.name?.split('&')?.[0]} </div>
                              </div>
                            ))}
                        </div>
                        <div className="categoryBorder" />
                        {subCategoryL2Data?.length === 0 && filteredData?.length > 0 && (
                          <SubL3Categories
                            subL3category={filteredData?.slice(0, 20)}
                            name={category?.name}
                            shopByBrand={shopByBrand?.[0]?.featuredBrandList}
                            pageType={pageType}
                            screenName={screenName}
                            showFullWidth
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        {(DEALS_OPTION?.active || EXPRESS_OPTION?.active) && aemegamenu && (
          <div
            className={` ${categoryList.length <= 6 ? 'static-options-small' : ''}  ${
              categoryList.length > 6 ? 'static-options' : ''
            }`}
          >
            {aemegamenu && (
              <div className="static-card combined">
                {DEALS_OPTION?.active &&
                  <div
                    className="option deals"
                    onMouseEnter={() => setIsDealsHovered(true)}
                    onMouseLeave={() => setIsDealsHovered(false)}
                    onClick={() => {
                      dataLayerMenuClick(screenName, pageType, DEALS_OPTION?.name, 'Mega menu');
                      handleStaticOptionClick(DEALS_OPTION.url, DEALS_OPTION.name, 'homepage_static_menu_link');
                    }}
                  >
                    <div className="image">
                      <Image
                        src={
                          isDealsHovered ? getImageUrlWithSize(aemegamenu?.commonmenu?.Deals?.hover, 12, 12) : getImageUrlWithSize(aemegamenu?.commonmenu?.Deals?.nothover, 12, 12)
                        }
                        width={12}
                        height={12}
                        unoptimized
                      />
                    </div>
                    <span className="dealsname" style={{ color: isDealsHovered ? '#388E3C' : 'inherit' }}>
                      {DEALS_OPTION.name}
                    </span>
                  </div>
                }
                {EXPRESS_OPTION?.active &&
                  <div
                    className="option express"
                    onMouseEnter={() => setIsExpressHovered(true)}
                    onMouseLeave={() => setIsExpressHovered(false)}
                    onClick={() => {
                      dataLayerMenuClick(screenName, pageType, EXPRESS_OPTION?.name, 'Mega menu');
                      handleStaticOptionClick(EXPRESS_OPTION.url, EXPRESS_OPTION.name, 'homepage_static_menu_link')
                    }}
                  >
                    <div className="image_express">
                      <Image
                        src={
                          isExpressHovered
                            ? getImageUrlWithSize(aemegamenu?.commonmenu?.Express?.hover, 12, 12)
                            : getImageUrlWithSize(aemegamenu?.commonmenu?.Express?.nothover, 12, 12)
                        }
                        width={12}
                        height={12}
                        unoptimized
                      />
                    </div>
                    <span className="expressname" style={{ color: isExpressHovered ? '#388E3C' : 'inherit' }}>
                      {EXPRESS_OPTION.name}
                    </span>
                  </div>
                }
              </div>
            )}
          </div>
        )}
      </div>
    </MegaMenuStyled>
  );
};

MegaMenu.propTypes = {
  categoryList: PropTypes.array,
  shopByBrand: PropTypes.array,
  screenName: PropTypes.string,
  pageType: PropTypes.string,
};
MegaMenu.defaultProps = {
  categoryList: [],
  shopByBrand: [],
  screenName: '',
  pageType: '',
};
export default MegaMenu;
